export const GETTERS_TRANSACTION_LIST = "GETTERS_TRANSACTION_LIST";
export const GETTERS_TRANSACTION_LIST_LOADING =
  "GETTERS_TRANSACTION_LIST_LOADING";
export const GETTERS_TRANSACTION_ASSOCIATED_LIST =
  "GETTERS_TRANSACTION_ASSOCIATED_LIST";
export const GETTERS_TRANSACTION_ASSOCIATED_PAGINATION =
  "GETTERS_TRANSACTION_ASSOCIATED_PAGINATION";
export const GETTERS_TRANSACTION_DETAIL = 'GETTERS_TRANSACTION_DETAIL';

// action
export const ACTION_GET_TRANSACTION_LIST = "ACTION_GET_TRANSACTION_LIST";
export const ACTION_GET_TRANSACTION_ASSOCIATED_LIST =
  "ACTION_GET_TRANSACTION_ASSOCIATED_LIST";
export const ACTION_GET_TRANSACTION_DETAIL = 'ACTION_GET_TRANSACTION_DETAIL';

export const MUTATION_GET_TRANSACTION_LIST = "MUTATION_GET_TRANSACTION_LIST";
export const MUTATION_SET_TRANSACTION_LIST_LOADING =
  "MUTATION_SET_TRANSACTION_LIST_LOADING";
export const MUTATION_GET_TRANSACTION_ASSOCIATED_LIST =
  "MUTATION_GET_TRANSACTION_ASSOCIATED_LIST";
export const MUTATION_GET_TRANSACTION_DETAIL = 'MUTATION_GET_TRANSACTION_DETAIL';



// WEBPACK FOOTER //
// ./src/store/modules/transactions/constants.js